import { Subscription } from 'types';

export const isTeamsPlan = (subscription: Subscription) => {
  return (
    subscription?.prices?.products?.name === 'Teams' ||
    subscription?.prices?.products?.name === 'Teams 6 seats' ||
    subscription?.prices?.products?.name === 'Teams 5 seats' ||
    subscription?.prices?.products?.name === 'Teams 10 seats' ||
    subscription?.prices?.products?.name === 'Teams 20 seats' ||
    subscription?.prices?.products?.name === 'Teams 30 seats' ||
    subscription?.prices?.products?.name === 'Teams 40 seats' ||
    subscription?.prices?.products?.name === 'Teams 200' ||
    subscription?.prices?.products?.name === 'Teams 300' ||
    (subscription?.additional_seats != null &&
      subscription.additional_seats > 0)
  );
};
